const TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImtpZCI6ImRzemhfdG9rZW5fa2V5aWQifQ.eyJpc3MiOiJEU0pXVF9JU1MiLCJpYXQiOjE3NDkwNDQ1ODAsImRhdGEiOnsidXNlcl9pZCI6IjE4NjE4NDk0ODIxIiwiY2hhbm5lbCI6IjEwMDAifSwic2NvcGVzIjoicm9sZV9hY2Nlc3MiLCJleHAiOjE3NTQyMjg1ODB9.tQgP99rqdGuGOGjZ3dqi3tMC998hQmTwJjgJQguRAak';
const PUBLIC_API_BASE_URL = (process.env.VUE_APP_PUBLIC_API_BASE_URL || 'https://api.yubinglabs.com').replace(/\/$/, '');

function buildPublicApiUrl (path) {
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${PUBLIC_API_BASE_URL}${normalizedPath}`;
}
export {
    TOKEN,
    PUBLIC_API_BASE_URL,
    buildPublicApiUrl
};
